import { ITimesPlayedInTournament } from '@fantaz/shared/data-access/api';
import {
  CasualTournamentEntity,
  EventSchedule,
  TournamentType,
  RoomFilterModel,
} from '@fantaz/shared/data-access/models';
import { createAction, props } from '@ngrx/store';

export const loadCasualTournaments = createAction(
  '[CasualTournament Page] Load Casual Tournaments',
  props<{
    tournamentType?: TournamentType;
    retiredEvents?: boolean;
    comingSoonOnly?: boolean;
    active?: boolean;
  }>(),
);

export const loadCasualTournamentSuccess = createAction(
  '[CasualTournament/API] Load CasualTournament Success',
  props<{ casualTournament: CasualTournamentEntity[] }>(),
);

export const loadCasualTournamentFailure = createAction(
  '[CasualTournament/API] Load CasualTournament Failure',
  props<{ error: any }>(),
);

export const filterTournamentsByGames = createAction(
  '[CasualTournament Page] Filter By Games',
  props<{ games: string[] }>(),
);

export const clearFilterTournamentsByGames = createAction(
  '[CasualTournament Page] Clear Filter By Games',
);

export const searchTournaments = createAction(
  '[CasualTournament Page] Search',
  props<{ searchTerm: string }>(),
);

export const loadSubscriptionTournament = createAction(
  '[CasualTournament Page] Load Subscription Tournament',
  props<{ eventPrototypeUuid: string; eventSchedule: EventSchedule }>(),
);

export const loadSubscriptionTournamentSuccess = createAction(
  '[CasualTournament Page] Load Subscription Tournament Success',
  props<{
    eventPrototypeUuid: string;
    eventSchedule: EventSchedule;
    status: boolean;
  }>(),
);

export const clearSearchTournaments = createAction(
  '[CasualTournament Page] Clear Search',
);
export const loadSubscriptionTournamentFailure = createAction(
  '[CasualTournament/API] Load CasualTournament Failure',
  props<{ error: any }>(),
);

export const addRoomFilter = createAction(
  '[CasualTournament Page] Add Room Filter',
  props<{ filters: RoomFilterModel[] }>(),
);
export const clearRoomFilters = createAction(
  '[CasualTournament Page] Clear Filters',
);
export const addLastTab = createAction(
  '[CasualTournament Page] Add Room Filter',
  props<{ lastTab: TournamentType | undefined }>(),
);
export const clearLastTab = createAction(
  '[CasualTournament Page] Clear Filters',
);
export const getTimesUserTournamentPlayed = createAction(
  '[CasualTournament Page] Times User Tournament Played',
  props<{ tournamentList: string[] }>(),
);
export const getTimesUserTournamentPlayedSuccess = createAction(
  '[CasualTournament Page] Times User Tournament Played Success',
  props<{ timesPlayedInTournament: ITimesPlayedInTournament[] }>(),
);
export const getTimesUserTournamentPlayedFailure = createAction(
  '[CasualTournament Page] Times User Tournament Played Failure',
  props<{ error: unknown }>(),
);
